import { AppButton } from 'components';
import ManageCourseBundles from './ManageCourseBundles';
import useToaster from 'hooks/useToaster';
import { useState } from 'react';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import TablePaginate from 'components/Paginate';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import useManageCourseBundles from 'hooks/API/useManageCourseBundles';
import useCourseBundles from 'hooks/API/GET/useCourseBundles';
import * as AppPics from 'assets/images';

function MainCourseBundles() {
  const [params, setParams] = usePaginateDefaults();
  const [selectedBundle, handleSelectedBundle] = useState({});
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const {
    isLoading: loading,
    data,
    isError: listingError,
  } = useCourseBundles({ enabled: true, configs: { params } });
  const { isLoading, mutate, isError } = useManageCourseBundles();
  const { meta: { page, total } = {} } = data?.data ?? {};

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function manageEs(data) {
    if (isLoading) return;

    mutate(data);
    closeSModal();
  }

  function closeSModal() {
    handleDeleteSModal({ show: false, data: {} });
    handleSelectedBundle({});
  }

  return (
    <>
      <BasicDelete
        open={deleteSModal.show}
        closeModal={closeSModal}
        Header="Delete course bundle"
        handleConfirmation={() => {
          if (loading) return;

          manageEs({ id: deleteSModal?.data?._id, type: 'DELETE' });
        }}
      />
      <div className="mainWraper">
        <div className="container-fluid outerborder">
          <ManageCourseBundles
            save={manageEs}
            selectedItem={selectedBundle}
            handleSelectedItem={handleSelectedBundle}
          />
          <div className="tableWrap">
            <div className="table-responsive">
              <table className="table tableWrap__table">
                <thead className="thead-light __appTheadColor">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" className="w20">
                      Bundle Name
                    </th>
                    <th scope="col" className="w20" colSpan="2">
                      Courses
                    </th>
                    <th scope="col" className="align-center">
                      Action
                    </th>
                  </tr>
                </thead>
                {loading ? (
                  <tbody>
                    <tr>
                      <td>Loading...</td>
                    </tr>
                  </tbody>
                ) : listingError ? (
                  <tbody>
                    <tr>
                      <td>Failed to load data</td>
                    </tr>
                  </tbody>
                ) : data?.data?.result?.length > 0 ? (
                  <tbody>
                    {data?.data?.result?.map?.((result, index) => {
                      return (
                        <tr key={result._id}>
                          <th scope="row">{index + 1}</th>
                          <td>{result.name}</td>
                          <td colSpan="2">
                            {result?.courses?.map((x) => x.courseName)?.join(', ')}
                          </td>
                          <td className="align-center">
                            <AppButton
                              className="actions-icons mx-2 text-primary"
                              onClick={() => {
                                handleSelectedBundle(result);
                              }}
                              title="Edit"
                            >
                              <img src={AppPics.EditSvg} alt="edit this option" />
                            </AppButton>

                            <AppButton
                              className="actions-icons mx-2 text-danger"
                              onClick={() => {
                                handleDeleteSModal({ show: true, data: result });
                              }}
                              title="Delete"
                            >
                              <img src={AppPics.DeleteSvg} alt="delete this option" />
                            </AppButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="5">No records found</td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <TablePaginate
            maxCount={total}
            currentPage={page}
            defaultLimit={params.limit}
            setPage={(page) => setParams((x) => ({ ...x, page }))}
            handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
          />
        </div>
      </div>
    </>
  );
}

export default MainCourseBundles;
